function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
export const AnchorIcon = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#blue)",
  d: "M18.066 22.009C20.71 22.479 24 16.85 24 16.85l-6.289.418c-.81 2.395-.996 4.181.355 4.74Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#purple)",
  d: "M18.154 3.689c-.587-.877-.378-.966-1.464-1.134-.345-.052-.565-1.315-3.78.382C8.615 5.204 1.76 12.96 0 15.34l8.38-.557c1.9-2.274 5.706-6.537 7.937-7.676 1.479-1.045 2.607-2.267 1.837-3.418Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#pink)",
  d: "M20.215 11.656c.126-.287.24-.504.298-.646 1.159-2.834 2.488-4.776.739-6.898-1.192-1.446-4.41-2.881-7.149-1.729 1.16-.249 2.036-.168 2.6.68.991 1.491-1.073 4.649-1.836 6.298-.808 1.746-1.688 3.468-2.273 5.309-.423 1.333-.773 3.04.16 4.243.808 1.042 3.106 2.293 3.745 2.573.547.239 1.132.5 1.732.544-2.45-.998.312-6.584 1.984-10.374Z"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "blue",
  x1: "13.713",
  x2: "27.257",
  y1: "20.444",
  y2: "16.126",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".18",
  stopColor: "#4A0D73"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".277",
  stopColor: "#7C2091"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".374",
  stopColor: "#A731AB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".461",
  stopColor: "#C53DBD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".535",
  stopColor: "#D845C8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".586",
  stopColor: "#DF48CD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "purple",
  x1: "21.605",
  x2: "-3.884",
  y1: "2.44",
  y2: "31.077",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".045",
  stopColor: "#001480",
  stopOpacity: ".898"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".079",
  stopColor: "#063194",
  stopOpacity: ".918"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".162",
  stopColor: "#1673C1",
  stopOpacity: ".953"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".233",
  stopColor: "#21A3E2",
  stopOpacity: ".976"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".286",
  stopColor: "#28C1F7",
  stopOpacity: ".992"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".316",
  stopColor: "#2BCDFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".429",
  stopColor: "#3EDBDB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".562",
  stopColor: "#52EAB7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".634",
  stopColor: "#5AF0AA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pink",
  x1: "5.418",
  x2: "35.817",
  y1: "34.15",
  y2: "19.65",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".423",
  stopColor: "#643CFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".609",
  stopColor: "#7268FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".774",
  stopColor: "#7D89FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".865",
  stopColor: "#8296FF"
}))));